import * as React from 'react';

import { useAccessControl } from '~/common/hooks';
import { AccessDecisionStrategy } from '~/common/types';

interface Props {
  roles: Array<string>;
  children: React.ReactNode;
  strategy?: AccessDecisionStrategy;
}

const PrivateComponent: React.FC<Props> = ({
  roles,
  children,
  strategy = 'affirmative',
}) => {
  const acl = useAccessControl();
  const canSee = acl.isGranted(roles, strategy);

  if (!canSee) {
    return <></>;
  }
  return <>{children}</>;
};

export default PrivateComponent;
